import React from 'react';
import PropTypes from 'prop-types';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalTalentContents.scss';
import {
    Grid,
    cls,
    HeaderCompound,
} from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import {getLastTouch} from "../../requests/utils/utils-last-touch";

import utilsSearch from '../../utils/Search';
import Card from '../CardNew';
import getBadges from '../../utils/Badges';
import Scrollable from '../Scrollable';
import { getBookmark } from '../../requests/loader';
import Device from '../../devices/device';
import { MODAL_TALENT_CONTENTS, MODAL_FAIL_FILTER_TALENTS } from '../../actions/modal';
import RibbonCategories from '../RibbonNew/RibbonTypes/RibbonCategories/index';
import Vertical from '../../requests/tasks/search/VerticalTask';
import RequestManager from '../../requests/RequestManager';
import store from '../../store';
import { showModal } from '../../actions/modal';
import Utils from "../../utils/Utils";
import {isActiveFocusDynamic} from "../Focus/utils";
import {ID_NAME_MODAL_TALENT} from "../Focus/constants";
import {removeDynamicFocus} from "../../../src/components/Focus/utils";
const MAIN_CLASSNAME = 'aaf-modal-talent-contents';
const NAME_FIRST_ELEMENT = 'focus_modaltalent_0'//Translator.get('search_talents_filter_label', 'TODOS');

class ModalTalentContents extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            gridItems: [],
            isLoading: true,
        };
        this.closeModal =this.closeModal.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.keys = Device.getDevice().getKeys();
    }

    closeModal(){
        const { handleClose = ()=>{} } = this.props;
        handleClose();
    }

    getGroupIds(items){
        return items.map(it=>it.id);
    }

    addBookmarkToItems(items, bookmark){
        return items.map(it=>{
            if(bookmark[it.id]){
                it.progress = bookmark[it.id];
            }
            return it;
        })
    }

    parseBookmark(groups){
        const bookmark = {};
        groups.forEach(group=>{
            const {
                vistime: { last: { progress = 0 } = {} } = {}
            } = group;
            bookmark[group.id] = progress;
        });
        return bookmark;
    }

    getAssetErrorIcon(result){
      return result && result.error && result.error.code ? `${result.error.code}_icon` : false;
    }

    getGridItems(id_rol = "", name = NAME_FIRST_ELEMENT){
        const { talent, providerIdFromVCard = null } = this.props;
      const { lastTouchSeen } = this.state;
      const {
            fullname,
            id,
            provider_id = ''
        } = talent;
        let providerId = providerIdFromVCard ||  provider_id;
        if(isNaN(providerId)) {
            providerId = '';
        }

            const verticalTask = new Vertical(id, utilsSearch.getSearchField().Talent, providerId, 0, 20, id_rol);
            RequestManager.addRequest(verticalTask)
            .then((result) => {
              const items = result.response && result.response.groups ? result.response.groups : null;
              if(Array.isArray(items) && items.length>0){
                const groupIds = this.getGroupIds(items);
                getBookmark(groupIds.join(','), lastTouchSeen).then(res =>{
                    if(res && res.response && Array.isArray(res.response.groups)){
                        const bookmarkObj = this.parseBookmark(res.response.groups);
                        const newItems = this.addBookmarkToItems(items,bookmarkObj)
                        this.updateItems(newItems, name);
                    }
                    else{
                        this.updateItems(items, name);
                    }
                }).catch(err=>{
                    console.log('getBookmark err',err);
                    this.updateItems(items, name);
                });
              }
              else{
                  this.setState({isLoading:false});
                  const assetIcon = this.getAssetErrorIcon(result);
                  store.dispatch(showModal({modalType: MODAL_FAIL_FILTER_TALENTS, modalProps: { assetIcon }}));
              }
            })
            .catch((err) => {
              store.dispatch(showModal({modalType: MODAL_FAIL_FILTER_TALENTS}));
            });


    }

    updateItems(items, className){
        this.setState({gridItems: items, isLoading: false}, ()=>{
            window.SpatialNavigation.focus(`.${className}`);
        })
    }

    componentDidMount(){
      getLastTouch("seen").then(lastTouchSeen => {
        this.setState({ lastTouchSeen });
      })
        this.getGridItems();
        this.removeEventListener();
        this.addEventListener();
    }

    componentWillUnmount(){
        this.removeEventListener();
    }

  async handleKeyDown(e){
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    //Id elemento focusable de abajo del foco actual
    const focusDownId = e.target.getAttribute('data-sn-down');
    //Id elemento focusable de arriba del foco actual
    const focusUpId = e.target.getAttribute('data-sn-up');
    //Numero de id del elemento focusable de arriba del foco actual
    const numNextUp = focusUpId ? parseInt(focusUpId.split('_')[2]) - 4 : null;
    //Elemento focusable de abajo del foco actual
    const elementFocusDown = document.querySelector(focusDownId);
    //Elemento focusable de arriba del foco actual
    const elementFocusUp = document.querySelector(focusUpId)

    if(currentKey === 'YELLOW'){
      this.closeModal();
    }
    else if(currentKey === 'LEFT'){
      const validateClassNameTarget = e.target.classList.contains(NAME_FIRST_ELEMENT);
      if(validateClassNameTarget){
        e.preventDefault();
        e.stopPropagation();
      }
    }
    else if(currentKey === 'DOWN'){
      const validateClassNameTarget = e.target.classList.contains("aaf_button");
      const idTarget = Array.isArray(this.state.gridItems) && this.state.gridItems.length>0 ? this.state.gridItems[0].id : 0;

      if(validateClassNameTarget){
        window.SpatialNavigation.focus(`#link-${idTarget}`);
      }
      elementFocusDown && elementFocusDown.scrollIntoView({ block: "start"});
    }
    else if(currentKey === 'UP'){
      const validateClassNameTarget = e.target.classList.contains("aaf_button");
      if(validateClassNameTarget){
        window.SpatialNavigation.focus(".aaf_colored-button-yellow-principal");
      }
      elementFocusUp && elementFocusUp.scrollIntoView({ block: "start"});
    }

  }

    addEventListener(){
        document.addEventListener('keydown', this.handleKeyDown);
    }

    removeEventListener(){
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    transformRolesToVisibleItems(roles){
      const firstElement = {
        item: {title: NAME_FIRST_ELEMENT,
        href: '',
        id: 0,
        id_rol: "",
      }
      }
      const visibleItems = roles.map(({NOMBRE, ID}, index)=>{
        return {
          item: {
            id: index + 1,
            title: NOMBRE,
            href: '',
            id_rol: ID,
          }
        }
      });
      return [firstElement, ...visibleItems];
    }

    handleScroll(event) {
        removeDynamicFocus();
    }

    render() {
        const modalProps = {
            childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
        };
        const {
            talent: {
                name = '',
                surname = '',
                roles = [],
            } ={},
            setMetricsEvent = ()=>{},
            user,
            handleClose =()=>{}
        } = this.props;
        const { gridItems, isLoading } = this.state;
        return (
            <ModalWrapper {...modalProps}>
                <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.closeModal}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Asset.get('top_head_option_back')}`}/>
                    <div className={`${MAIN_CLASSNAME}-talent-name`}>{`${name} ${surname}`}</div>
                    <div className='wrapper-filter-modal-talent'>
                      { roles.length >= 2 && <RibbonCategories
                          history={this.props.history}
                          visibleItems={this.transformRolesToVisibleItems(roles)}
                          onClick={(id_rol, name = NAME_FIRST_ELEMENT)=>this.getGridItems(id_rol, name)}
                          />
                      }
                    </div>
                    <Scrollable
                        className={`${MAIN_CLASSNAME}-grid-scrollabe`}>
                        {isLoading ? null : <div className="card-grid" style={{textAlign: "left", "overflow-y": "scroll", height: "500px"}} onPointerMove={this.handleScroll} onWheel={this.handleScroll}>
                            {Array.isArray(gridItems) && gridItems.length>0 && gridItems.map((r, index) =>{

                                let tempFormatTypes = (typeof r.format_types === 'object') ? r.format_types : r.format_types.split(',');
                                if (tempFormatTypes.length === 2 && tempFormatTypes[0] === "est" && tempFormatTypes[1] === "ppe") {
                                  tempFormatTypes = tempFormatTypes.reverse();
                                }
                                else {
                                    tempFormatTypes = r.format_types;
                                }

                                const badges = getBadges(
                                    user,
                                    r.proveedor_code,
                                    tempFormatTypes,
                                    r.live_enabled
                                );
                                const cardProps = {
                                    key: index,
                                    index: index,
                                    ribbonId: `${ID_NAME_MODAL_TALENT}`,
                                    cover: r.image_small,
                                    group_id: r.group_id || r.id,
                                    title: r.title,
                                    hideInnerTitle: false,
                                    type: 'classic',
                                    focusable: true,
                                    badges: badges,
                                    provider: r.provider || null,
                                    live_enabled: r.live_enabled || null,
                                    id: index,
                                    data: r,
                                    onClick: e => {
                                        handleClose();
                                    },
                                    setMetricsEvent: setMetricsEvent,
                                    display: MODAL_TALENT_CONTENTS,
                                    bookmark: r.progress,
                                    focusDown: index <= 3 ? null : `#${ID_NAME_MODAL_TALENT}_classic_link_${index + 4}`,
                                    focusUp: index > 3 ? `#${ID_NAME_MODAL_TALENT}_classic_link_${index - 4}` : null,
                                };
                                return (
                                    <Card
                                        {...cardProps}
                                    />
                                )
                            })}
                            {gridItems.length === 0 && <p>{Translator.get('no_content_modal_talent', "Sin contenidos")}</p>}
                        </div>}
                    </Scrollable>
                </Grid>
            </ModalWrapper>
        );
    }
}

ModalTalentContents.defaultProps = {
    talent: {}
};

ModalTalentContents.propTypes = {
    talent: PropTypes.object
};

export default withOnClose(ModalTalentContents);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTalentContents.jsx